<i18n>
[
    "browse__clearFilters--title",
]
</i18n>

<template>
    <div class="c-catalog-empty-filtered-content u-spacer--12">
        <template v-if="contentfulContent">
            <component
                :is="contentfulContentBlockComponent"
                :contentRows="contentfulContent"
                class="u-spacer--2"
            />
            <div class="o-flex-horizontal-center">
                <span v-tab-focus="resetFilters" class="o-text--link">
                    {{ t('browse__clearFilters--title') }}
                </span>
            </div>
        </template>
    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

import { useLogger } from '~coreModules/core/js/composables/useLogger';
import { useContentfulSvc } from '~coreModules/core/js/composables/useContentfulSvc';

import { CONTENT_TYPES, CONTENT_SLUGS } from '~coreModules/contentful/js/contentful-constants';
import { getContentfulPageContentForSlug } from '~coreModules/contentful/js/contentful-client';
import { shapeContentfulContentPageResponse } from '~coreModules/contentful/js/contentful-utils';

const props = defineProps({
    contentfulContentBlockComponent: {
        type: [Function, Object],
        required: true,
    },
    getClearAllFiltersLinkObject: {
        type: Function,
        required: true,
    },
    emptyFilteredContentSlug: {
        type: String,
        default: CONTENT_SLUGS.EMPTY_FILTERED_CATALOG_CONTENT_SLUG,
    },
});

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const contentfulSvc = useContentfulSvc();
const logger = useLogger();

const contentfulContent = ref(null);

function resetFilters() {
    const { query } = route;

    router.replace(props.getClearAllFiltersLinkObject?.(query));
}

async function getContentfulContent() {
    try {
        const response = await getContentfulPageContentForSlug({
            contentfulSvc,
            contentType: CONTENT_TYPES.CONTENT_SLOT,
            slug: props.emptyFilteredContentSlug,
            isTimed: false,
        });
        contentfulContent.value = shapeContentfulContentPageResponse(response)?.rows;
    } catch (error) {
        logger.debugError('Contentful content not found for slug no-filter-results: ', error);
    }
}

onBeforeMount(async () => {
    await getContentfulContent();
});

</script>

<style lang="scss">
</style>
